// Application configuration
export const config = {
	apiBaseUrl: import.meta.env.VITE_REACT_APP_API_BASE_URL,
	isDevelopment: import.meta.env.VITE_ENV,
	microsoftClientId: import.meta.env.VITE_REACT_APP_MICROSOFT_CLIENT_ID,
	microsoftTenantId: import.meta.env.VITE_REACT_APP_MICROSOFT_TENANT_ID,
	microsoftRedirectUri: `${window.location.origin}${import.meta.env.VITE_REACT_APP_MICROSOFT_REDIRECT_URI}`,

	// Other configuration
	defaultPageSize: 10,
	maxUploadSize: 10 * 1024 * 1024, // 10MB

	// API Endpoints
	endpoints: {
		auth: {
			login: "/api/Auth/login",
			logout: "/api/Auth/logout",
			refresh: "/api/Auth/refresh",
			profile: "/api/Auth/profile",
			verify: "/api/Auth/verify",
			microsoft: "/api/Auth/microsoft",
		},
		bachelorDegrees: "/api/BachelorDegrees",
		masterDegrees: "/api/MasterDegrees",
		languageCertificates: "/api/LanguageCertificates",
		gdqpCertificates: "/api/NationalDefenseEducationCertificates",
		awards: "/api/Awards",
		scholarships: "/api/Scholarships",
		scholarshipTitles: "/api/ScholarshipTitles",
		users: "/api/Users",
		public: {
			search: "/api/PublicSearch/search",
		},
	},
};

// Helper function to get full API URL
export const getApiUrl = (endpoint: string): string => {
	return `${config.apiBaseUrl}${endpoint}`;
};

// Helper function to update config at runtime if needed
export const updateConfig = (updates: Partial<typeof config>): void => {
	Object.assign(config, updates);
};
